import React from 'react'
import { useState, useEffect } from 'react'
import { OverlayTrigger, Spinner} from 'react-bootstrap'
import { ZoomInOutlined, ZoomOutOutlined, RedoOutlined } from '@ant-design/icons';
import "./ViewComponent.css";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Button, Tooltip} from 'antd';
import PdfModal from './Pdfviewer';
import Hexapi from '../../utility/HexAPI/Hexapi';
import { useSelector } from 'react-redux';
import Loader from '../loader/Loader';


function Attachment(props) {
 
    const [base64, setBase64] = useState('')
    const [isloadcomplete, setIsloadcomplete] = useState(false)
    const [image, setImage] = useState('')
    const [openmodal, setOpenmodal] = useState(false)
    const [isDisableWatermark, setIsDisableWatermark] = useState(props.isDisableWatermark)
    const [openpdfreader, setOpenpdfreader] = useState(false)
    const [isFileDownloadComplete, setIsFileDownloadComplete] = useState(false)
    const[fileext,setfileext]=useState('')
    const[filename,setfilename]=useState(null)
    const[filetype,setfiletype]=useState('')

    const user = useSelector(state => state?.users?.data?.[""]?.[0]);
    const username = user?.username ? user?.username : null
    
    const fetchAttachment = () => {
        setIsFileDownloadComplete(false)
        const obj={
          query:`HrApp_Droid_Proc_User_GetAttachment @AttachmentID='${props.attID}',@UserID ='${props.userid}'`,
          queryArr:[`${props.attID}`,`${props.userid}`]
        }
        Hexapi(obj).then(resp => {
          console.log(resp,"Resp")
            let base64Type = ""
            let extension = resp[''][0]['extension'];

            setfileext(extension)
            props.setextensionget(extension)
            setfilename( resp[''][0]['filename'])
            props.setfilenameget(resp[''][0]['filename'])
            setfiletype(extension)
            switch (extension) {
                case ".zip": base64Type = "application/x-zip-compressed"; break;
                case ".txt": base64Type = "text/plain"; break;
                case ".doc": base64Type = "application/msword"; break;
                case ".xls": base64Type = "application/vnd.ms-excel"; break;
                case ".ppt": base64Type = "application/vnd.ms-powerpoint"; break;
                case ".png": base64Type = "image/png"; break;
                case ".jpg": base64Type = "image/jpg"; break;
                case ".pdf": base64Type = "application/pdf"; break;
                case ".jpeg": base64Type = "image/jpeg"; break;
                case ".mpeg": base64Type = "audio/mpeg"; break;
                default: break;
            }
            setIsloadcomplete(true)
            const imageData = `data:${base64Type};base64,${resp[''][0].attachment}`;
            setBase64(imageData);
            setIsloadcomplete(true);
            
            setImage(`data:${base64Type};base64,${resp[''][0].attachment}`)
            props.setImageData(imageData)
            props.setisdownload(false)
  
        }).then(resp => {
            setIsFileDownloadComplete(true)
        }).catch(err => console.error("Document Fetching Error: ", err))
    }
    useEffect((e) => {
        fetchAttachment(-1);
            setTimeout(() => {
                if ( fileext== ".pdf") {
                    setOpenpdfreader(true)
                }
            }, 300);



    }, [fileext])

    const openModal = (type) => {
            if (type == -1) {
                setOpenmodal(true)
            } else if (type == ".pdf") {
                setOpenpdfreader(true)
            }
    }
    useEffect(()=>{
    if( fileext !=='' && fileext.endsWith(".pdf")){
    openModal(".pdf")
}
    },[fileext])
    // const urlWithParams = `${image}#toolbar=0&navpanes=0&scrollbar=0`;

    return (
        <>
        { fileext !== "" && fileext !== null ? <div className="container-fluid" id="attatchmentBox">
                {
                     fileext == "" && filetype === "-1" ? ""
                        : fileext.endsWith('.png') ||fileext.endsWith('.jpg') || fileext.endsWith('.jpeg')  ?

                        <div>
                          <TransformWrapper
  initialScale={1}
  minScale={1}
  maxScale={8}
  centerOnInit={true}
  limitToBounds={true}
  panning={{ velocityDisabled: true }}
  wheel={{ step: 0.2, smoothness: 0.5 }}
  pinch={{ disabled: false, step:0.8, smoothness: 0.8 }}
  doubleClick={{ step: 1.2 }}
  rotation={{ step: 10, smoothness: 0.2 }}
>
  {({ zoomIn, zoomOut, resetTransform ,rotate}) => (

    <>

      <div
        style={{
          position: "absolute",
          top: 10,
          right: 80,
          display: "flex",
          gap: "8px",
          zIndex: 10,

        }}
      >
       
          <Tooltip placement="top" title="Zoom In">
          <Button className='textbuttonsty' onClick={() => zoomIn()}><ZoomInOutlined /></Button>
      </Tooltip>
            <Tooltip placement="top" title="Zoom Out">
          <Button className='textbuttonsty' onClick={() => zoomOut()}><ZoomOutOutlined /></Button>
      </Tooltip>
      
          <Tooltip placement="top" title="Reset Zoom">
          <Button className='textbuttonsty' onClick={() => {resetTransform()}}><RedoOutlined /></Button>
          </Tooltip>
      </div>

      <TransformComponent>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100vw",
            height: "95vh",
          }}
        >
          <img
            src={base64}
            alt="Zoomable"
            className="img-fluid"
            style={{
              width: "auto",
              height: "auto",
              maxWidth: "80vw",
              maxHeight: "80vh",
              objectFit: "contain",
              touchAction: "none",
              userSelect: "none",
              transition: 'transform 0.3s ease',
            }}
          />
        </div>
      </TransformComponent>
    </>
  )}
</TransformWrapper>
 {isDisableWatermark == 0 && (
    <span  className="pdfreadermainboxx" style={{ fontSize: '20px', position: 'absolute', top: "50%", left: "46%", zIndex: 10 }}>
      {`${username} (${props.userid})`}
    </span>
  )}
                      </div>

                            : fileext.endsWith(".pdf") ?

                           <div
  className="pdfreadermainbox"
  style={{
    width: '100%',
    height: '80vh',
    position: 'relative',
  }}
>
  {isDisableWatermark == 0 && (
    <span style={{ fontSize: '20px', position: 'absolute', top: "50%", left: "46%", zIndex: 10 }}>
      {`${username} (${props.userid})`}
    </span>
  )}

{
  image !== null && <PdfModal base64Pdf={image} show={true}/>
}

</div>

                                :
                                <><div className='displayImage' style={{ height: "70vh", width:"70vw", display:"flex", justifyContent:"center", alignItems:"center", backgroundColor: "rgba(46, 45, 45, 0.56)" ,padding:"20px" }}>
                                    <h4>No Preview Available</h4>
                                </div>
                                    <p style={{ color: "#000" ,textAlign:"center", marginTop:"3px" }}><b> {filename}{fileext}</b></p>
                                </>

                }

            </div> : <div style={{textAlign:"center"}}>
              
                <Loader/>
                </div>}


        </>
    )
}

export default Attachment